export const CACHE_KEY_LIST_AUDITOR_AUDITS = 'auditorAudits';
export const CACHE_KEY_AUDITOR_AUDITS = 'auditorAudits-one';
export const ROUTE_PATH_AUDITOR_AUDITS = '/auditor/audits';
export const TRANSLATION_PREFIX_AUDITOR_AUDITS = 'auditorAudits';
export const AUDITOR_AUDITS_DIALOG_NAME_SPACE = 'run-audit-preview-dialog';
export const CACHE_KEY_LIST_AUDITOR_AUDITS_SECTIONS = 'audit-sections';
export const CACHE_KEY_SECTIONS_MANIFEST = 'audit-sections-manifest';

export const STATUS_AUDIT = {
  Draft: 'draft',
  Accepted: 'accepted',
  Running: 'running',
  Finished: 'finished',
};

export const CONTACT_POOLS_FIELDS = [
  'pools_reported',
  'pools_audited',
  'pools_not_audited'
];
